import getSafe from '../../utils/getSafe';
import {
  CREATE_PAYMENT_PLAN,
  CREATE_PAYMENT_PLAN_REQUEST,
  CREATE_PAYMENT_PLAN_FAILURE,
  CREATE_PAYMENT_PLAN_SUCCESS,
  EXECUTE_PAYMENT_PLAN,
  EXECUTE_PAYMENT_PLAN_FAILURE,
  EXECUTE_PAYMENT_PLAN_SUCCESS,
  EXECUTE_PAYMENT_PLAN_REQUEST,
  DISMISS_ERRORS,
} from './types';

export const initialState = {
  lastAction: null,
  paymentPlanId: null,
  errors: {
    hasDismissed: true,
    network: null,
    graphql: [],
  },
  paymentOptions: {
    completing: [],
    selectedCompleting: null,
    newCardConfig: null,
  },
  addresses: {
    available: [],
    selected: null,
  },
  lineItemGroups: [],
  fulfillmentDetails: null,
  executionState: null,
  executePaymentPlanData: {},
  isLoading: false,
  translatedContent: {
    addNewAddressCta: 'Add a new address',
    addNewPaymentCardCta: 'Add Payment Method',
  },
};

const parsePaymentPlan = (payload) => {
  // Can be undefined if there is an error
  if (!payload.data) {
    return {};
  }

  const {
    id,
    paymentOptions,
    deliveryAddresses,
    lineItemGroups,
    fulfillmentDetails,
    executionState,
  } = payload.data.paymentPlan;

  return {
    paymentPlanId: id,
    paymentOptions: {
      selectedCompleting: paymentOptions.selectedCompleting,
      completing: paymentOptions.completing,
      newCardConfig: {
        tokenizer: paymentOptions.newCardConfig.tokenizer,
        apiKey: paymentOptions.newCardConfig.apiKey,
      },
    },
    addresses: deliveryAddresses.available,
    selectedAddress: deliveryAddresses.selected,
    lineItemGroups,
    fulfillmentDetails,
    executionState,
    translatedContent: {
      addNewAddressCta: deliveryAddresses.addNewAddressCta,
      addNewPaymentCardCta: paymentOptions.newCardConfig.addCardCta,
    },
  };
};

const parseNetworkError = (action) => ({
  status: action.status,
  errors: action.payload.errors,
  message: action.message,
});

const checkoutPaymentReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_PAYMENT_PLAN_REQUEST:
      return {
        ...state,
        lastAction: CREATE_PAYMENT_PLAN,
        isLoading: true,
      };
    // GraphQL response, could include errors
    case CREATE_PAYMENT_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: {
          hasDismissed: false,
          network: initialState.errors.network,
          graphql: action.payload.errors || initialState.errors.graphql,
        },
        ...parsePaymentPlan(action.payload),
      };
    // Network failure, eg, not a 200, could be bad query
    case CREATE_PAYMENT_PLAN_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          hasDismissed: false,
          network: parseNetworkError(action),
          graphql: initialState.errors.graphql,
        },
      };
    case EXECUTE_PAYMENT_PLAN_REQUEST:
      return {
        ...state,
        lastAction: EXECUTE_PAYMENT_PLAN,
        isLoading: true,
      };
    case EXECUTE_PAYMENT_PLAN_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          hasDismissed: false,
          network: parseNetworkError(action),
          graphql: initialState.errors.graphql,
        },
      };
    case EXECUTE_PAYMENT_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: {
          hasDismissed: false,
          network: initialState.errors.network,
          graphql: getSafe(() => action.payload.errors) || initialState.errors.graphql,
        },
        executePaymentPlanData: getSafe(() => action.payload.data.executePaymentPlan) || {},
      };
    case DISMISS_ERRORS:
      return {
        ...state,
        errors: {
          ...state.errors,
          hasDismissed: true,
        },
      };
    default:
      return state;
  }
};

export default checkoutPaymentReducer;
